import { useRecordContext } from 'react-admin';
import { ActionButtonProps } from '@/components/buttons/ActionButton/types';
import { useRunRequest } from '@/hooks';
import { TurnResourcesEnum, TurnTargetsEnum } from '@/types/turn-enums';
import { useState } from 'react';

const useController = () => {
  const record = useRecordContext();
  const { runRequest } = useRunRequest();
  const [needsCmAction, setNeedsCmAction] = useState(false);

  const toggleNeedsCmAction = (needsCmAction: boolean) => setNeedsCmAction(needsCmAction);

  const runMatchAction = async () => {
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.MonitoringCriminal,
      params: {
        id: record.id,
        target: TurnTargetsEnum.Match,
      },
      useResponseDialog: true,
    });
  };

  const runNoMatchAction = async () => {
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.MonitoringCriminal,
      params: {
        id: record.id,
        target: TurnTargetsEnum.NoMatch,
      },
      useResponseDialog: true,
    });
  };

  const stopRechecksAction = async () => {
    await runRequest({
      fetchType: 'UPDATE',
      resource: TurnResourcesEnum.MonitoringCriminal,
      params: {
        id: record.id,
        target: TurnTargetsEnum.StopRecheck,
      },
      useResponseDialog: true,
    });
  };

  const actionButtonCommonProps: Partial<ActionButtonProps> = {
    disabled: !needsCmAction,
    iconType: 'addCircleOutline',
  };

  return {
    actionButtonCommonProps,
    runMatchAction,
    runNoMatchAction,
    stopRechecksAction,
    toggleNeedsCmAction,
  };
};

export default useController;
